import { _className } from '../../../utils/classname.utils';
import { renderIf } from '../../../utils/render.utils';
import BackIcon from '../Icons/BackIcon';
import CrossIcon from '../Icons/CrossIcon';
import style from './BottomSheet.css';
import { useEffect, useState } from 'preact/hooks';

export default function BottomSheet({
  className = '',
  onCloseClick,
  onBackClick,
  title = '',
  fullScreen = false,
  footerActions,
  children,
  ...props
}) {
  const [showing, setShowing] = useState(false);
  useEffect(() => {
    setShowing(true);
    document.querySelector('html').style.overflow = 'hidden';
    return () => {
      document.querySelector('html').style.overflow = 'visible';
    };
  }, []);

  const handleTouchOutside = () => {
    onCloseClick();
  };

  return (
    <div
      className={`${style.overlay} ${_className(showing, style.showing)} `}
      onClick={handleTouchOutside}
    >
      <div
        className={`${className} ${style['bottom-sheet']} ${_className(
          showing,
          style['showing'],
        )} ${_className(fullScreen, style['full-screen'])}`}
        {...props}
        onClick={e => e.stopPropagation()} // Prevents the click event from reaching the overlay
      >
        <div className={style.header}>
          {renderIf(
            fullScreen,
            <button
              className={`${style['icon-button']} ${style['icon-button--back']}`}
              onClick={onBackClick}
            >
              <BackIcon className={style['back-icon']} />
            </button>,
          )}

          <span>{title}</span>
          <button
            type="button"
            className={`${style['icon-button']} ${style['icon-button--close']}`}
            onClick={onCloseClick}
          >
            <CrossIcon />
          </button>
        </div>
        <div className={style.body}>{children}</div>
        {renderIf(
          footerActions,
          <div className={style.footer}>{footerActions}</div>,
        )}
      </div>
    </div>
  );
}
